import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import loadingReducer from './loadingSlice';
import formReducer from './form/formSlice';
import groupReducer from './group/groupSlice';
import customerReducer from './customer/customerSlice';
import contactUsReducer from './contactUs/contactUsSlice';

import licenseReducer from './license/licenseSlice';
export const store = configureStore({
  reducer: {
    auth: authReducer,
    loading: loadingReducer,
    form: formReducer,
    group: groupReducer,
    customer: customerReducer,
    contactUs: contactUsReducer,
    license: licenseReducer,
  },
});

